import { AddNewButtonShell } from '@/components/RootScreenButtons/buildingBlocks/AddNewButtonShell';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';
import { cleanLocalStorageKey } from '@/utils/cleanLocalStorageKey';

export const AddNewInternalOrderButton = () => {
  const t = useTranslation();
  const { push } = useAppPush();
  return (
    <AddNewButtonShell
      onClick={() => {
        cleanLocalStorageKey('INTERNAL_ORDER_FORM');
        push('/orders/new-internal?orderEditOrigin=root');
      }}
    >
      {t('section.ADD_NEW_INTERNAL_ORDER')}
    </AddNewButtonShell>
  );
};
